<div class="content">
  <div class="columns">
    <div class="column is-6">
      <ng-select [items]="datasetItems" bindLabel="name" [virtualScroll]="true" class="custom has-tooltip-bottom"
                 placeholder="Select..." [ngModel]="selectedDataset" (ngModelChange)="select($event)"
                 data-tooltip="Choose the dataset for cancer driver genes." [clearable]="false"
      >
                 <!-- [groupBy]="groupingHelper" -->
        <ng-template ng-option-tmp let-item="item">
          {{item.name}} ({{item.count}})
        </ng-template>
      </ng-select>
    </div>

    <div class="column">
      <div *ngIf="selectedDataset" class="info">

        <div *ngIf="selectedDataset.link"><a href="{{selectedDataset.link}}" target="_blank"><i class="fas fa-link"></i> Source</a></div>
        <div *ngIf="selectedDataset.count">Number of genes: {{selectedDataset.count}}</div>
        <div *ngIf="selectedDataset.version">Version: {{selectedDataset.version}}</div>
      </div>
    </div>
  </div>
</div>
